/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BranchService = {
  async getByName(name) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `Description eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getDefault(params) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `IsDefault eq 'Y'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getManufactureBranch(params) {
    const requestScreenData = {
      url: "api/Branch",
      filter: `Inactive eq 'N' and ManufactureFlag eq 'Y'`,
      select: ["Code", "Description", "Inactive", "ManufactureFlag", "ManufactureBranchCode"]
    };

    return await ApiService.oDataGet(requestScreenData);
  }
};

export { BranchService };
